import { render, staticRenderFns } from "./creditList.vue?vue&type=template&id=5f3b8aa0&scoped=true&"
import script from "./creditList.vue?vue&type=script&lang=ts&"
export * from "./creditList.vue?vue&type=script&lang=ts&"
import style0 from "./creditList.vue?vue&type=style&index=0&id=5f3b8aa0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3b8aa0",
  null
  
)

export default component.exports